import React, { useRef } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Importing arrow icons
import "./Gallery.css";

const Gallery = ({ images }) => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <div className="gallery-container">
      <button className="nav-button left" onClick={scrollLeft}>
        <FaArrowLeft />
      </button>
      <div id="mz-gallery" className="mz-gallery">
        <div className="images-container" ref={sliderRef}>
          {images?.map((image) => (
            <img className="image" alt="sliderImage" src={image} />
          ))}
        </div>
      </div>
      <button className="nav-button right" onClick={scrollRight}>
        <FaArrowRight />
      </button>
    </div>
  );
};

export default Gallery;
